(ns frontend.view.entity-viewers.modules.decisions.view
  (:require
   [common.localization :as loc]
   [common.schema.entity-types :as entity-types]
   [common.util :as cu]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.modals.decisions.event :as decision-modal-event]
   [frontend.view.modals.decisions.view :as decision-modal]
   [frontend.view.modals.events :as modals]
   [re-frame.core :as rf]
   [ui.color :as c]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.components.radix-ui.dropdown-menu.view :refer
    [dropdown-menu-arrow
     dropdown-menu-content
     dropdown-menu-item
     dropdown-menu-portal
     dropdown-menu-root
     dropdown-menu-trigger]]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.components.text.view :as text]))

(defn decision-status
  [decision]
  (case (:entity/type decision)
    :entity.type/aifm-decision
    (:decision/portfolio-manager-approves-proposed-investment decision)

    :entity.type/ic-decision
    (:decision/ic-approves-proposed-investment decision)

    :entity.type/aifm-exit-decision
    (:decision/portfolio-manager-approves-proposed-exit decision)

    :entity.type/ic-exit-decision
    (:decision/ic-approves-proposed-exit decision)

    :entity.type/one-pager-decision
    (:decision/approval-status decision)

    :entity.type/icm-decision
    (:decision/approval-status decision)

    :entity.type/scm-decision
    (:decision/approval-status decision)

    nil))

(defn view
  [entity]
  (let [entity-id (:db/id entity)
        decisions (->> @session/decisions
                       (cu/filter-by :common/containing-entity entity-id)
                       (sort-by (fn [{:keys [decision/date
                                             common/created-on]}]
                                  (or date created-on))))]
    [:div
     {:class "pt-2 flex flex-col gap-2"}
     (if (empty? decisions)
       [:h2
        {:class "mb-0 ml-2 text-sm text-base-light-text-paler"}
        (loc/tr :no-associations-info-text
            ["decisions"])]
       (->>
        decisions
        (map
         (fn [decision]
           (let [decision-id (:db/id decision)
                 date (:decision/date decision)
                 label (loc/tr (:entity/type decision))
                 decision-status (decision-status decision)]
             ^{:key (str "decision-" decision-id)}

             [:div
              {:class    "px-3 py-2 flex justify-between items-center cursor-pointer border border-solid border-base-light-border-paler rounded"
               :on-click (fn []
                           (modals/open-modal! decision-modal/modal-key {:decision-id decision-id})
                           (rf/dispatch [::decision-modal-event/open-editor-modal decision-id]))}
              [:div
               {:class "flex gap-2 items-center"}
               [:div
                (case decision-status
                  :condition.status/true
                  [:i.fas.fa-check-circle
                   {:class "text-success-light-text"}]

                  :decision.status/approved
                  [:i.fas.fa-check-circle
                   {:class "text-success-light-text"}]

                  :condition.status/conditionally-true
                  [:i.fas.fa-check-circle
                   {:class "text-warning-regular"}]

                  :decision.status/conditionally-approved
                  [:i.fas.fa-check-circle
                   {:class "text-warning-regular"}]

                  :condition.status/postponed
                  [:i.fas.fa-clock
                   {:class "text-base-light-text"}]

                  :condition.status/false
                  [:i.fas.fa-times-circle {:class "text-danger-light-text"}]

                  :decision.status/rejected
                  [:i.fas.fa-times-circle {:class "text-danger-light-text"}]

                  [:i.fal.fa-circle])]
               [:div
                {:class "font-semibold mb-0 text-sm"}
                [:span label]]]
              [:div
               {:class "mb-0 text-sm text-base-light-text-paler"}
               (fu/format-date-ts date "." true)]])))))]))

; Every type must be added multiple
; Render decision date after decision type name
; Sort by type
; ON DEAL VIEW

(defn add-new-decision-button
  [viewed-entity]
  (let [viewed-entity-id (:db/id viewed-entity)
        viewed-entity-type (:entity/type viewed-entity)
        decision-configuration @session/decision-configuration
        enabled-decision-types
        (->> entity-types/decision-entity-types
             (filter (fn [entity-type]
                       (let [containing-entity-types
                             (get-in decision-configuration [:containing-entity-types entity-type])]
                         (some #{viewed-entity-type} containing-entity-types)))))
        decision-type-options (->> enabled-decision-types
                                   (map (fn [decision-entity-type]
                                          {:value decision-entity-type
                                           :label (loc/tr decision-entity-type)}))
                                   (sort-by :label))]
    [:div
     (cond
       (empty? decision-type-options)
       [tooltip/view
        [:i
         {:class (fu/cs "fal" "fa-exclamation-triangle")
          :style {:color (c/color ::c/danger)}}]
        [:span
         [text/label
          {:class "text-secondary-gloomy-text"}
          (loc/tr :decision-feature-not-configured!)]
         (when (session/is-admin?)
           [:<> [:br]
            [:a
             {:class    "text-secondary-gloomy-text underline"
              :href     "/settings/decisions"
              :on-click (fn [e]
                          (routing/set-view! [:settings/decisions])
                          (.preventDefault e)
                          (.stopPropagation e))}
             (loc/tr :configure-here)]])]]

       (not (session/is-read-only-user?))
       [dropdown-menu/view
        {:trigger [dropdown-menu/button-trigger-open
                   [:i.fal.fa-plus-circle.text-md]]
         :class   "px-0"
         :items
         (->> decision-type-options
              (mapv (fn [{:keys [value label]}]
                      {:label    label
                       :on-click (fn []
                                   (let [decision-id (fu/create-temp-id "temp-decision-")]
                                     (modals/open-modal! decision-modal/modal-key {:decision-id decision-id})
                                     (rf/dispatch [::decision-modal-event/open-create-modal
                                                   decision-id
                                                   value
                                                   viewed-entity-id])))})))}])]))

(defn header-view
  [viewed-entity]
  (let []
    [:div
     {:class "[&_button]:w-4 [&_button]:max-w-4"}
     [add-new-decision-button viewed-entity]]))
